import Dashboard from '../pages/Dashboard';
import AddBranch from '../pages/Branch/AddBranch';
import Branches from '../pages/Branch/Branches';
import Brands from '../pages/Brand/Brands';
import Categories from '../pages/Category/Categories';
import Customers from '../pages/Customer/Customers';
import Products from '../pages/Products/Products';
import AddProduct from '../pages/Products/AddProduct';
import EditProduct from '../pages/Products/EditProduct';
import Orders from '../pages/Orders/Orders';
import CreateOrder from '../pages/Orders/CreateOrder';
import OrderDetails from '../pages/Orders/OderDetails';
import OrderConfirm from '../pages/Orders/OrderConfirm';
import EditOrderDetails from '../pages/Orders/EditOrderDetails';
import EditOrder from '../pages/Orders/EditOrder';
import Users from '../pages/User/Users';
import AddUser from '../pages/User/AddUser';
import Profile from '../pages/User/Profile';
import Settings from '../pages/Settings/Settings';
import CakeOrder from '../pages/Cakes/CakeOrder';

import { Cake } from '@mui/icons-material';

import CakeDetails from '../pages/Cakes/CakeDetails';
import CakeLists from '../pages/Cakes/CakeOrderLists';
import SubCategories from '../pages/SubCategory/SubCategories';
import EditCakeDetails from '../pages/Cakes/EditCakeDetails';
import CakeOrderLists from '../pages/Cakes/CakeOrderLists';
import EditCakeOrder from '../pages/Cakes/EditCakeOrder';
import CakeOrderConfirm from '../pages/Cakes/CakeOrderConfirm';
import Reports from '../pages/Reports/Reports';
import OrderApproval from '../pages/Approval/Approval';

const ROLE_ADMIN = 1;

const routeData = [
  { path: "/dashboard", element: <Dashboard /> },

  // Admin-only routes
  // { path: "/add-branch", element: <AddBranch />, roles: [ROLE_ADMIN] },
  { path: "/branches", element: <Branches />, roles: [ROLE_ADMIN] },
  { path: "/users", element: <Users />, roles: [ROLE_ADMIN] },
  { path: "/add-user", element: <AddUser />, roles: [ROLE_ADMIN] },
  { path: "/approval", element: <OrderApproval />, roles: [ROLE_ADMIN] },
  

  // Common routes for all roles
  { path: "/brands", element: <Brands /> },
  { path: "/categories", element: <Categories /> },
   { path: "/sub-categories", element: < SubCategories/> },
  { path: "/customer", element: <Customers /> },
  { path: "/products", element: <Products /> },
  { path: "/add-product", element: <AddProduct /> },
  { path: "/edit-product/:id", element: <EditProduct /> },
  { path: "/orders", element: <Orders /> },
  { path: "/create-order", element: <CreateOrder /> },
  { path: "/order-details", element: <OrderDetails /> },
  { path: "/order-confirm", element: <OrderConfirm /> },
  { path: "/edit-order-details/:id", element: <EditOrderDetails /> },
  { path: "/edit-order/:id", element: <EditOrder /> },
  { path: "/profile", element: <Profile /> }, 
  { path: "/settings", element: <Settings /> },
  { path: "/cake", element: <Cake /> },
  { path: "/cakeorder", element: <CakeOrder /> },
  { path: "/reports", element: <Reports /> },
  { path: "/cake-details", element: <CakeDetails /> },
  { path: "/cake-lists", element:<CakeLists /> },
  { path: "/edit-cake-details/:id", element: <EditCakeDetails /> },
  {path: "/cake-orders", element: <CakeOrderLists/>},
  {path:"/edit-cake-order/:id", element:<EditCakeOrder/>},
  { path: "/cake-order-confirm", element: <CakeOrderConfirm /> },
];

export default routeData;
